<template>
  <li class="action-list_item">
    <a :href="offer.detailsUrl" @click="onClickOffer" class="action" :class="expired && 'action__expired'">
      <img class="action_img" :src="offer.imageUrl" :alt="offer.title">
        <OfferTimer @expired="onExpired" :expired="expired" :startDate="offer.startDate" :endDate="offer.endDate"/>
      <div class="action_title">
        <h2 class="heading2 heading2__inherit" v-text="offer.title"></h2>
      </div>
      <p class="action_paragraph" v-text="offer.description"/>
    </a>
  </li>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import OfferTimer from './OfferTimer'

@Component({ components: { OfferTimer } })
class Offer extends Vue {
  @Prop(Object) offer
  expired = false

  onExpired () {
    this.expired = true
  }

  onClickOffer () {
    this.$analytics.trackPromotionLinkClick({
      screenId: this.$route.name,
      linkUrl: this.offer.detailsUrl,
      promotionId: this.offer.offerId
    })
  }
}

export default Offer
</script>
